import { Link } from "react-router-dom";
import { timeAgo } from "@/lib/api";

const KIND_LABEL = { creation: "Creation", challenge: "Challenge", feedback: "Feedback" };
const STATUS_TONE = {
  open: "text-white/50 border-white/20",
  planned: "text-[#3f82ff] border-[#3f82ff]/40",
  "in progress": "text-ember border-ember/40",
  done: "text-[#35c978] border-[#35c978]/40",
  "won't do": "text-white/30 border-white/15",
};

export default function PostCard({ post }) {
  return (
    <Link
      to={`/community/${post.post_id}`}
      data-testid={`post-card-${post.post_id}`}
      className="block panel rounded-2xl p-6 hover:border-forge/40 hover:-translate-y-0.5 transition-[transform,border-color] duration-300"
    >
      <div className="flex items-center gap-3 mb-3 flex-wrap">
        <span className="display text-[10px] tracking-[0.25em] text-forge">
          {KIND_LABEL[post.kind]}
        </span>
        {post.creation_type && (
          <span className="text-[10px] uppercase tracking-wider text-white/40">{post.creation_type}</span>
        )}
        {post.feedback_type && (
          <span className="text-[10px] uppercase tracking-wider text-ember">{post.feedback_type}</span>
        )}
        {post.status && post.kind === "feedback" && (
          <span
            className={`text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full border ${
              STATUS_TONE[post.status] || STATUS_TONE.open
            }`}
          >
            {post.status}
          </span>
        )}
        <span className="text-[11px] text-white/25">{timeAgo(post.created_at)}</span>
      </div>

      <h3 className="headline text-2xl mb-2">{post.title}</h3>
      {post.body && <p className="text-sm text-white/50 leading-relaxed line-clamp-3">{post.body}</p>}

      {post.contents?.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-4">
          {post.contents.slice(0, 6).map((c, i) => (
            <span key={i} className="text-[11px] px-2.5 py-1 rounded-lg bg-white/[0.05] text-white/60">
              {c}
            </span>
          ))}
        </div>
      )}

      {post.tags?.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {post.tags.map((t) => (
            <span key={t} className="text-[10px] px-2 py-0.5 rounded-full border border-white/10 text-white/35">
              #{t}
            </span>
          ))}
        </div>
      )}

      <div className="mt-5 flex items-center gap-4 text-[11px] text-white/35">
        <span>{post.author_name}</span>
        <span>♥ {post.like_count}</span>
        <span>{post.comment_count} comments</span>
        {post.kind === "challenge" && <span>{post.join_count} in</span>}
        {post.duration && <span>{post.duration}</span>}
        {post.difficulty && <span>{post.difficulty}</span>}
      </div>
    </Link>
  );
}
